import { isVendorEnabled, thirdPartyKeys } from '@/config/thirdParty';
/**
 * Google Tag Manager.
 *
 * Three independent switches, and conflating them is the mistake to avoid:
 *
 *  - `enabled`     -- whether `$gtm.trackView` / `$gtm.trackEvent` do anything.
 *                     Roughly 20 components call these; the plugin installs
 *                     `$gtm` either way, so turning this off is safe but it also
 *                     silences the dataLayer.
 *  - `loadScript`  -- whether the gtm.js script is fetched from Google. This is
 *                     the only one that makes a network call to a third party.
 *  - `debug`       -- console logging only.
 *
 * The container id used to be hardcoded here. It now comes from
 * `VUE_APP_GTM_ID`, and an unset or placeholder id means the script is not
 * loaded at all. See docs/third-party-scripts.md.
 */
const containerId = thirdPartyKeys.gtmId();
const allowed = isVendorEnabled('gtm');
/**
 * Load the script only when the vendor is allowed *and* we have a real
 * container id. Previously this was decided by a hostname ladder that also
 * silently enabled a hardcoded container on `dev.asq.global`.
 */
const GTM_LOAD = allowed && Boolean(containerId);
/**
 * Keep the dataLayer API alive locally so component-level tracking calls are
 * exercised in development without anything leaving the browser. Nothing is
 * sent when `loadScript` is false: there is no gtm.js to forward it.
 */
const GTM_ENABLED = GTM_LOAD || process.env.NODE_ENV !== 'production';
const GTM_DEBUG = process.env.NODE_ENV !== 'production';
export default {
    // vue-gtm requires a string; with GTM_LOAD false it is never dereferenced.
    id: containerId || 'GTM-DISABLED',
    defer: false,
    compatibility: true,
    vueRouter: false,
    enabled: GTM_ENABLED,
    debug: GTM_DEBUG,
    loadScript: GTM_LOAD,
    trackOnNextTick: false
};
